import React from "react";
import clsx from "clsx";

import { Layers2, ChevronDown } from "lucide-react";

import useCurrentEnvironment from "../hooks/use-environment";

interface EnvironmentDisplayProps {
  collapsed?: boolean;
  onClick: () => void;
  open: boolean;
}

export const EnvironmentDisplay = React.forwardRef<
  HTMLButtonElement,
  EnvironmentDisplayProps
>(({ collapsed = false, onClick, open }, ref) => {
  const currentEnvironment = useCurrentEnvironment();

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <button
      className={clsx(
        "hover:bg-nav-hover focus:outline-nav-focus mb-4 flex w-full cursor-pointer items-center rounded-lg border border-white/10 transition-all duration-550 ease-[cubic-bezier(0.16,1,0.3,1)] focus:outline",
        collapsed ? "mx-2 h-10 justify-center" : "mx-3 gap-3 px-3 py-2",
        open && "bg-nav-selected",
      )}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      ref={ref}
      aria-expanded={open}
      aria-label="Select environment"
    >
      <Layers2 size={20} className="flex-shrink-0 text-white" />
      <div
        className={clsx(
          "flex flex-1 items-center justify-between overflow-hidden transition-[opacity,max-width] duration-550 ease-[cubic-bezier(0.16,1,0.3,1)]",
          collapsed ? "max-w-0 opacity-0" : "max-w-full opacity-100",
        )}
      >
        <div className="min-w-0 text-left">
          <div className="text-xs font-bold text-white/60">
            {currentEnvironment?.project?.name}
          </div>
          <div className="text-sm font-bold text-white">
            {currentEnvironment?.name}
          </div>
        </div>
        <ChevronDown
          size={20}
          className="flex-shrink-0 -rotate-90 text-white"
        />
      </div>
    </button>
  );
});
